export const en = {
    'rejected-on-moderation': 'Moderation not passed'
};
